import {  INPUTBOX_SET_FOCUS,
    RESTORE_ALME_WINDOW,
    SET_RESET_FUNCTION_FLAG,
    STAGE_GET_CRM,
    SET_LAUNCH_PROACTIVE_FLAG,
    SET_LAST_URL_LAUNCHED_FROM,
    SET_CHANNEL,
    SET_LAUNCH_POINT_NAME
} from './actionTypes';

export function restoreAlmeWindow(stateLocation: string) {
    return {
        type : RESTORE_ALME_WINDOW,
        payload : {
        stateLocation,
        },
    };
}

export function inputboxSetFocus(stateLocation: string) {
    return {
        type : INPUTBOX_SET_FOCUS,
        payload : {
        stateLocation,
        },
    };
}

export function setResetFunctionFlag(stateLocation: string, value: boolean){
    return {
        type : SET_RESET_FUNCTION_FLAG,
        payload : {
        stateLocation,
        value,
        },
    };
}

export function stageGetCrm(payload: any) {
    return {
        type: STAGE_GET_CRM,
        payload,
    };
}

export function setLaunchProctiveFlag(stateLocation: string, value: boolean) {
    return {
        type: SET_LAUNCH_PROACTIVE_FLAG,
        payload: {
            stateLocation,
            value,
        },
    };
}

export function setLastUrlLaunchedFrom(stateLocation: string, value: string) {
    return {
        type: SET_LAST_URL_LAUNCHED_FROM,
        payload: {
            stateLocation,
            value,
        },
    };
}

export function setChannel(value: string) {
    return {
        type: SET_CHANNEL,
        payload: {
            channel: value,
        },
    };
}

export function setLaunchPointName(launchPointName: string) {
    return {
        type: SET_LAUNCH_POINT_NAME,
        payload: {
            launchPointName: launchPointName,
        },
    };
}



// WEBPACK FOOTER //
// ./modules/window-launch/actions/actions.ts